module.exports = __webpack_public_path__ + "media/images/sponsorImage-8895b901f98d61337d8c5f58cd165787.png";